import * as tslib_1 from "tslib";
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of, zip } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { DocumentActionTypes, DeleteDocumentSuccess, DeleteDocumentFailure, } from '../actions/document.actions';
import { ReloadCrpList } from 'store/actions/customer.actions';
import { DocumentsService } from 'modules/core/services/documents.service';
var DocumentEffects = /** @class */ (function () {
    function DocumentEffects(actions$, documentService) {
        var _this = this;
        this.actions$ = actions$;
        this.documentService = documentService;
        this.deleteDocument$ = this.actions$.pipe(ofType(DocumentActionTypes.DELETE_DOCUMENT), mergeMap(function (res) {
            return zip(of(res.payload), _this.documentService.deleteDocument(res.payload)).pipe(mergeMap(function (_a) {
                var crpId = _a[0], deleteResponse = _a[1];
                return [
                    new DeleteDocumentSuccess(deleteResponse),
                    new ReloadCrpList(deleteResponse)
                ];
            }), catchError(function (error) {
                return of(new DeleteDocumentFailure(error.message));
            }));
        }));
    }
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], DocumentEffects.prototype, "deleteDocument$", void 0);
    return DocumentEffects;
}());
export { DocumentEffects };
